"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeBase64 = exports.encodeBase64 = exports.getMD5Hash = void 0;
const md5 = require("md5");
const universal_base64_1 = require("universal-base64");
function getMD5Hash(input) {
    return md5(input);
}
exports.getMD5Hash = getMD5Hash;
function encodeBase64(input) {
    return (0, universal_base64_1.encode)(input);
}
exports.encodeBase64 = encodeBase64;
function decodeBase64(input) {
    return (0, universal_base64_1.decode)(input);
}
exports.decodeBase64 = decodeBase64;
//# sourceMappingURL=obfuscation.js.map